<mat-list-item (click)="onSendFeedback()">
    <mat-icon matListItemIcon>feedback</mat-icon>
    <a matListItemTitle>Send Feedback</a>
</mat-list-item>
